export default __webpack_public_path__ + "static/media/contrato_adopcion.0b62e126.docx";